import { render } from "./Quotation.vue?vue&type=template&id=666c8c30&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=en"
export * from "./Quotation.vue?vue&type=script&lang=en"

import "./Quotation.vue?vue&type=style&index=0&id=666c8c30&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666c8c30"]])

export default __exports__